import {authFetch} from "@/composables/useAuthFetch";

// each year's index, fetched once: the request itself is kept, so the many videos of a year that
// ask at the same moment share it (before, /Videos fetched each index three or four times)
const indexCache = new Map();

async function fetchSlidesIndex(yearValue) {
  try {
    const res = await fetch(`/${yearValue}/slides/index.json`);
    return res.ok ? await res.json() : [];
  } catch {
    return [];
  }
}

export function loadSlidesIndex(yearValue) {
  if (!indexCache.has(yearValue)) indexCache.set(yearValue, fetchSlidesIndex(yearValue));
  return indexCache.get(yearValue);
}

// the speaker's slides in the year's index: "Jodie_Jenkinson" or "masterclass/<Name>", else null.
// The PDFs sit at unguessable addresses (scripts/update/slides.js); fetchSlidesPath asks for one.
export function getSlidesKey(index, name) {
  const key = name.replace(/ /g, "_");
  if (index.includes(key)) return key;
  if (index.includes(`masterclass/${key}`)) return `masterclass/${key}`;
  return null;
}

// the lookup for a signed-in or signed-out user (fullstack /api/v1/slides/lookup), as the videos':
// {ok: true, path: "/files/<id>.pdf"} for whoever may watch the speaker's video, else {ok: false,
// action: "login" | "register" | "not_found", event?: "masterclass" | "workshop"}
export async function fetchSlidesLookup(yearValue, key) {
  const query = new URLSearchParams({year: yearValue, key});
  const response = await authFetch(`/api/v1/slides/lookup?${query}`);
  return response.ok ? await response.json() : {ok: false, action: "error"};
}
